import { createTheme } from '@mui/material/styles';

export const colors = {
  blue: '#417DFA',
  lightBlue: ' #417DFA80',
  paleBlue: '#e9f0ff',
  white: '#fff',
  lightGray: '#F6F6F6',
  gray: '#E8E8E8',
  darkGray: '#949494',
  darkGray2: '#A3A3A3',
  disabledGray: '#BBB',
  purple: '#281932',
  offWhite: '#D7DCCD',
  green: '#68FA50',
  darkGreen: '#31B81C',
  yellow: '#FAD141',
  darkYellow: '#F9D22D',
  lightPurple: '#878CDC',
  black: '#000',
};

export const theme = createTheme({
  palette: {
    primary: {
      main: '#417DFA',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: 'CommuterSans, sans-serif',
    h1: {
      fontSize: '1.5rem',
      fontFamily: 'CommuterSans, sans-serif',
    },
    h2: {
      fontSize: '1.3rem',
      fontFamily: 'CommuterSans, sans-serif',
    },
    h3: {
      fontSize: '1.1rem',
      fontFamily: 'CommuterSans, sans-serif',
    },
    body1: {
      fontFamily: 'Inter, sans-serif',
    },
    body2: {
      fontFamily: 'Inter, sans-serif',
    },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        standardSuccess: {
          backgroundColor: 'rgb(56, 142, 60)',
          color: 'white',
        },
        standardError: {
          backgroundColor: 'rgb(211, 47, 47)',
          color: 'white',
        },
        standardWarning: {
          backgroundColor: 'rgb(245, 124, 0)',
          color: 'white',
        },
        standardInfo: {
          backgroundColor: 'rgb(2, 136, 209)',
          color: 'white',
        },
      },
    },
  },
});
